import { useEffect } from "react";

import { mapToApiPage } from "./helpers";
import { Dispatch, PageSaveState, PageState, State } from "./StateManager/state";
import { SavePage } from "./types";

type Props = Readonly<{
  dispatch: Dispatch;
  pages: Array<PageState>;
  previousPage: number;
  savePage: SavePage;
  taxonomy: State["taxonomy"];
}>;

export const SavePageOnSave = ({ dispatch, pages, previousPage, savePage, taxonomy }: Props) => {
  useEffect(() => {
    if (previousPage >= 0 && pages[previousPage].pageSaveState === PageSaveState.Dirty) {
      dispatch({
        completed: false,
        failed: false,
        page: previousPage,
        type: "SAVE PAGE",
      });
      savePage(previousPage + 1, mapToApiPage(taxonomy)(pages[previousPage]), true).then(() => {
        dispatch({
          completed: true,
          failed: false,
          page: previousPage,
          type: "SAVE PAGE",
        });
      });
    }
  }, [previousPage]);
  return null;
};
SavePageOnSave.displayName = "SavePageOnSave";
